export default __webpack_public_path__ + "static/media/classicalcats_banner.cd483205.png";